import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";

import { EventBusService, EventsEnum } from "../common/event-bus.service";

@Component({
    selector: "app-spinner",
    templateUrl: "./spinner.component.html",
    styleUrls: ["./spinner.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SpinnerComponent implements OnInit {
  isVisible = false;
  message = "Please wait ...";

  constructor(private events: EventBusService) {}

  ngOnInit(): void {
    this.events.on(EventsEnum.SpinnerToggle).subscribe((event) => {
      this.isVisible = event.data;
    });
  }
}
